import { IconButton, Textarea } from '@bitrise/bitkit';
import { useCopyToClipboard } from 'usehooks-ts';
import { startBuildPath } from '@/utils/monolithApiRouteService';
import { snakeCaseKeys } from '@/utils/changeCase';
import { TriggerParams } from '@/models/TriggerParams';
import { HookInfo } from '@/models/HookInfo';
import FormBlock from '../FormBlock/FormBlock';
import getBuildParams from '../utils/getBuildParams';
import { BuildConfigurationType } from '../types';

export type CurlCommandProps = {
  buildTriggerToken: string;
  data: BuildConfigurationType;
  slug: string;
};

const CurlCommand = (props: CurlCommandProps) => {
  const { buildTriggerToken, data, slug } = props;

  const [, copy] = useCopyToClipboard();

  const { origin } = window.location;

  const buildParams = getBuildParams(data) as TriggerParams;

  const hookInfo = { buildTriggerToken, type: 'bitrise' } as HookInfo;

  const params = {
    buildParams,
    hookInfo,
    triggeredBy: 'curl',
  };

  const value = `curl ${origin}${startBuildPath(slug)} -L --data '${JSON.stringify(snakeCaseKeys(params))}' -H "Content-Type: application/json"`;

  return (
    <FormBlock isLastItem position="relative">
      <Textarea
        isRequired
        helperText="You can run this command on any platform which has cURL installed."
        label="Generated cURL command"
        value={value}
        sx={{
          textarea: {
            fontFamily: 'mono',
            minHeight: '12rem',
            paddingInlineEnd: '2.5rem',
          },
        }}
      />
      <IconButton
        iconName="Duplicate"
        aria-label="Copy to clipboard"
        size="sm"
        variant="tertiary"
        position="absolute"
        right="3"
        top="32"
        onClick={() => copy(value)}
      />
    </FormBlock>
  );
};

export default CurlCommand;
